export enum AutocompleteContentType {
  Article = 'articles.article',
  Company = 'companies.company',
  Event = 'events.event',
  Page = 'flatpages.page',
  Gallery = 'gallery.gallery',
  Meeting = 'meetings.meeting',
  Tag = 'tags.tag',
  User = 'users.user',
  Group = 'users.abakusgroup',
}
